<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="misc-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>
                    <div class="misc-desc">
                        <div class="slogen-misc"></div>
                        <div class="desc-item"><em class="label">1</em>任选1名主播陪玩一局（包括乱迷魂、妖刀等热门主播）</div>
                        <div class="desc-item"><em class="label">2</em>主播数量种类多样（包含竞技主播、副本带打、出征主播等）</div>
                        <div class="desc-item"><em class="label">3</em>官方全程补贴，无额外消费门槛。</div>
                    </div>
                    
                    <div class="qr-view">
                        <div class="img-qr">
                            <img :src="require('@/assets/images/modal/qr/'+ getRandomInt(1, 2) +'.jpg')" alt="">
                        </div>
                    </div>
                    
                    <div class="notice">微信扫码添加联系客服，咨询详情</div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>

.misc-modal{
    width: 700px;
    height: 669px;
    background-image: url(~@/assets/images/modal/bg-modal-misc.png);  
}

.title{
    width: 100%;
    height: 42px;
    margin: 0 auto 30px;
    background-repeat : no-repeat;
    background-position : center;
    background-image: url(~@/assets/images/modal/title-misc.png);     
}

.misc-desc{
    .slogen-misc{
        width: 551px;
        height: 31px;
        margin: 0 auto 20px;
        background-image: url(~@/assets/images/modal/slogen-misc.png); 
    }
}

.desc-item{
    position: relative;
    width: 502px;
    height: 36px;
    margin: 0 auto 5px;
    padding-left: 40px;
    font-size: 18px;
    color: #f8e1dc;
    line-height: 36px;

    .label{
        position: absolute;
        left: 0;
        top: 0;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-size: 20px;
        color: #fff;
        background-color: #b44e40;
        border-radius: 3px;
    }
}


.qr-view{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 443px;
    height: 442px;
    margin: -70px auto 0;
    background-image: url(~@/assets/images/modal/qr-view.png); 

    .img-qr{
        width: 204px;
        height: 204px;

        img{
            width: 100%;
            height: 100%;
        }
    }
}

.notice{
    width: 100%;
    margin: -70px auto 0;
    text-align: center;
    font-size: 16px;
    color: #f8e1dc;
}
</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            type : 'notice',
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
        this.$disableScroll();
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$enableScroll();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },           
        closeModal(){
            this.destroyElement()
        },
        getRandomInt(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1)) + min;
        },             
    },    
}
</script>